import { TrendingUp, Heart, Check } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";

const INVESTMENT_IMAGE = "/assets/images/huatulco-investment.webp";
const LIFESTYLE_IMAGE = "/assets/images/santa-cruz-beach.webp";

const InvestmentLifestyleSection = () => {
  const { t } = useLanguage();

  return (
    <section className="bg-white" data-testid="investment-lifestyle-section">
      <div className="text-center py-16 md:py-20 max-w-7xl mx-auto px-4 md:px-8">
        <span className="text-xs uppercase tracking-[0.3em] text-[#B5613B] font-accent mb-4 block">{t.investmentLifestyle.whyLabel}</span>
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-[#2D2926]">A Smart Investment in a Unique Destination</h2>
      </div>

      <div className="grid lg:grid-cols-2 min-h-[600px]">
        <div className="flex flex-col justify-center p-8 md:p-12 lg:p-16 bg-[#FAF8F5] order-2 lg:order-1" data-testid="investment-column">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-14 h-14 rounded-full bg-[#B5613B]/10 flex items-center justify-center">
              <TrendingUp className="w-7 h-7 text-[#B5613B]" />
            </div>
            <h3 className="font-heading text-3xl md:text-4xl text-[#B5613B]">{t.investmentLifestyle.investmentTitle}</h3>
          </div>
          <p className="text-[#6B6560] text-lg leading-relaxed mb-8">{t.investmentLifestyle.investmentDesc}</p>
          <ul className="space-y-4">
            {t.investmentLifestyle.investmentPoints.map((point, index) => (
              <li key={index} className="flex items-start gap-3">
                <Check className="w-5 h-5 text-[#D4A03D] flex-shrink-0 mt-1" />
                <span className="text-[#2D2926]">{point}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="relative h-[400px] lg:h-auto overflow-hidden order-1 lg:order-2">
          <img src={INVESTMENT_IMAGE} alt="Huatulco Bay View" className="w-full h-full object-cover" loading="lazy" decoding="async" />
        </div>
      </div>
      
      <div className="grid lg:grid-cols-2 min-h-[600px]">
        <div className="relative h-[400px] lg:h-auto overflow-hidden">
          <img src={LIFESTYLE_IMAGE} alt="Santa Cruz Beach Huatulco" className="w-full h-full object-cover" loading="lazy" decoding="async" />
        </div>
        <div className="flex flex-col justify-center p-8 md:p-12 lg:p-16 bg-[#FAF8F5]" data-testid="lifestyle-column">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-14 h-14 rounded-full bg-[#B5613B]/10 flex items-center justify-center">
              <Heart className="w-7 h-7 text-[#B5613B]" />
            </div>
            <h3 className="font-heading text-3xl md:text-4xl text-[#B5613B]">{t.investmentLifestyle.lifestyleTitle}</h3>
          </div>
          <p className="text-[#6B6560] text-lg leading-relaxed mb-8">{t.investmentLifestyle.lifestyleDesc}</p>
          <ul className="space-y-4">
            {t.investmentLifestyle.lifestylePoints.map((point, index) => (
              <li key={index} className="flex items-start gap-3">
                <Check className="w-5 h-5 text-[#D4A03D] flex-shrink-0 mt-1" />
                <span className="text-[#2D2926]">{point}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default InvestmentLifestyleSection;
